import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosNew from "../../store/api/axiosNew";
import { FaBell, FaMapPin } from "react-icons/fa";
import { ListGroup, Badge, Spinner } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";



export default function NotificationPage() {

    const navigate = useNavigate()
    const [notifications, setNotifications] = useState([])
    const [loading, setLoading] = useState(false)
    const isMobile = useMediaQuery({ maxWidth: 576 })

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                setLoading(true)
                const userId = localStorage.getItem("id")
                const res = await axiosNew.get(`/notification/${userId}`)
                if (res.data.success && Array.isArray(res.data.data)) {
                    setNotifications(res.data.data)
                }
                else {
                    setNotifications([])
                }
            }
            catch (err) {
                console.error("Error fetching notifications:", err)
            }
            finally {
                setLoading(false)
            }
        }
        fetchNotifications()
    }, [])

    const handleNotificationClick = async (notification) => {
        try {
            await axiosNew.patch(`/notification/${notification._id}/read`)
  navigate(`/user-dashboard?selectedleadid=${notification.leadId._id}`);
        }
        catch (err) {
            console.error("Error marking notification as read:", err)
        }
    }

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                <Spinner animation="border" variant="primary" />
            </div>
        )
    }

    return (
        <div style={{ margin: "0 auto", padding: "20px" }}>
            <h3 style={{ marginBottom: "20px", color: "#001927" }}>
                <FaBell style={{ marginRight: "8px", color: "#007bbd" }} />{" "} Notifications
            </h3>
            {notifications.length === 0 ? (
                <p style={{ textAlign: "center", color: "#888" }}>No notifications found</p>
            ) : (
                <ListGroup>
                    {notifications.map((n) => (
                        <ListGroup.Item key={n._id} action onClick={() => handleNotificationClick(n)} style={{
                            background: n.isRead ? "#fff" : "#f5faff", borderLeft: n.isRead ? "4px solid transparent" : "4px solid #007bbd", padding: isMobile ? "8px" : "16px", marginBottom: "4px",
                        }} >
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 style={{ fontWeight: "600", marginBottom: "4px", fontSize: isMobile ? "14px" : "16px" }}>{n.leadId?.name || "Unknown Lead"}</h6>
                                    <p style={{ margin: 0, fontSize: isMobile ? "12px" : "14px", color: "#555", fontWeight: "400" }}><FaMapPin style={{ color: "#007bbd", marginRight: "4px", fontSize: isMobile ? "14px" : "16px" }} />{n.leadId?.location || n.logId?.location || "Location not available"}</p>
                                    <small style={{ fontSize: isMobile ? "10px" : "12px", color: "#888" }}>{n.message}</small>
                                </div>
                                {!n.isRead && (
                                    <Badge bg="primary" pill>New</Badge>
                                )}
                            </div>
                            <small style={{ color: "#aaa" }}>{new Date(n.createdAt).toLocaleString()}</small>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}
        </div>
    )
}